import * as profiles from './list'

import { Profile } from 'app/types/users/profile'

export const allProfiles: Profile[] = Object.values(profiles).sort(
    (previous, current) => previous.name.localeCompare(current.name),
)
